import React from "react";
import { FormattedMessage } from "react-intl";

import styles from "../../src/styles/electrify-react.css";
import messages from "../lang/default-messages";

const electrifyComponent = function(props) {
	class ElectrifyReact extends React.Component {
		render() {
		    return (
		      <div className={styles.someStyle}>
		        <FormattedMessage {...messages.editMe} />
		      </div>
		    );
		}
	}
	
	ElectrifyReact.displayName = "ElectrifyReact";
	ElectrifyReact.propTypes = {};
	ElectrifyReact.defaultProps = {props};

	return ElectrifyReact;
}

export default electrifyComponent;



// WEBPACK FOOTER //
// ./src/components/electrify-react.jsx